import React from 'react';
import { Typography, Box } from '@mui/joy';

function EmptyMessageComponent({ title, description }: any) {

    return (
        <Box sx={{
            textAlign: 'center',
            padding: 4,
            maxWidth: 400,
            margin: '0 auto'
        }}>
            <Typography
                level="title-lg"
                sx={{
                    marginBottom: 2,
                    fontWeight: 600,
                    color: 'neutral.700'
                }}>
                {title}
            </Typography>
            <Typography
                level="body-sm"
                sx={{
                    color: 'neutral.500',
                    lineHeight: 1.6
                }}>
                {description}
            </Typography>
        </Box>
    );
}

export default EmptyMessageComponent;